import { ClaimsFilledSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/claims-filled-svg/claims-filled-svg.component';
import { ContactFilledSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/contact-filled-svg/contact-filled-svg.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, AfterViewInit, ElementRef, QueryList, ViewChildren, Output, Input, EventEmitter } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Capacitor } from '@capacitor/core';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { CompanyService } from '@services/my-insurance/company.service';
import { Router, NavigationEnd , RouterModule } from '@angular/router';

interface NavItem{
  routerLink: string,
  title: string,
  activeIcon: string,
  nonActiveIcon: string,
}

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, ContactFilledSvgComponent, ClaimsFilledSvgComponent],
  selector: 'app-loggedin-sidenav',
  templateUrl: './loggedin-sidenav.component.html',
  styleUrls: ['./loggedin-sidenav.component.scss'],
})
export class LoggedinSidenavComponent implements OnInit, AfterViewInit {
  @ViewChildren('menuItem', { read: ElementRef }) menuItems!: QueryList<ElementRef>;
  @Output() lockScreen :EventEmitter<boolean> = new EventEmitter();
  @Input() showMore = false;

  navItemList: any[];
  hiddenNavItems: NavItem[] = [];
  moreIcon: string;
  hiddenCount = 0;

  isAcmic: boolean;
  iphone: boolean;
  activePolicies: any;
  existMAPolicy: boolean;
  showCompany: string;
  isActiveAuto: any;

  constructor(
    private acmicService: AcmicService,
    private policyDataService: PolicyDataService,
    private companyService: CompanyService,
    private router: Router
    ) {
      this.existMAPolicy = false;
    }

  ngAfterViewInit() {
    window.addEventListener('resize', () => this.updateMenu());
    this.menuItems.changes.subscribe(()=> {
      this.updateMenu();
    })
    setTimeout(()=>this.updateMenu());
  }

  updateMenu() {
    const screenWidth = window.innerWidth;
    this.navItemList = this.menuItems.toArray();

    if(screenWidth <= 600 && this.navItemList.length > 4){
      this.hiddenCount = this.navItemList.length - 4;
      this.navItemList.slice(-this.hiddenCount).forEach(el => el.nativeElement.style.display = 'none');      
    } else {
      this.hiddenCount = 0;
      this.navItemList.forEach(el => el.nativeElement.style.display = 'block');
    }
  }

  checkForIphoneType(): boolean {
    // detection method by Mark Notton
    // https://codepen.io/marknotton/pen/MOpodJ?editors=1010
    const iOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    // Get the device pixel ratio
    const ratio = window.devicePixelRatio || 1;

    // Define the users device screen dimensions
    const screen = {
      width: window.screen.width * ratio,
      height: window.screen.height * ratio,
    };
    // iPhone X Detection
    if (iOS && screen.width == 1125 && screen.height === 2436) {
      return true;
    } else {
      return false;
    }
  }
  isActivePoliciesExists() {
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      let existMaPolicy = false;
      if (policyResponse) {
        existMaPolicy = policyResponse.some(policy => policy.company?.companyName == "MA");
        this.activePolicies = policyResponse.filter(policy => policy.policyStatus === 'ACTIVE');
        this.isActiveAuto= policyResponse.some(policy => policy.policyStatus === 'ACTIVE' && policy.policyType==='AUTO');
        if (policyResponse) {

          policyResponse.forEach(policy => 
           { 
            if (policy.company.companyName=="TW"){
              this.companyService.isTW = true;
            } else if (policy.company.companyName=="ACIC"){
              this.companyService.isAcicOnly = true;
            } else if (!(policy.company.companyName=="TW" || policy.company.companyName=="ACIC")) {
              this.companyService.isMa = true;
            }
          })

          this.companyService.getCompany();

        }

      }
      this.initHiddenNavItems(existMaPolicy);
    });
  }

  toggleMoreMenu(){
    this.showMore = !this.showMore;
    this.lockScreen.emit(this.showMore && this.hiddenCount > 0);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    if (Capacitor.getPlatform() == 'ios' && Capacitor.isNativePlatform()) {
      this.iphone = true;
    }
    this.detectStateCode();
    this.isActivePoliciesExists();
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    });
    this.moreIcon = this.isAcmic ? "./assets/img/images/more-icon-acmic.svg" : "./assets/img/images/more-icon.svg";
    this.routeEvent();
  }

  initHiddenNavItems(existMA: boolean){
    this.hiddenNavItems = []
    this.hiddenNavItems.push({
      routerLink: "/contact",
      title: "Contact",
      activeIcon: "./assets/img/images/menuicon-contact-active.svg",
      nonActiveIcon: this.isAcmic ? "./assets/img/images/Icon-Call.svg" : "./assets/img/images/menuicon-contact.svg"
    });
    if(this.isAcmic && this.activePolicies?.length && this.isActiveAuto){
      this.hiddenNavItems.push({
        routerLink: "/id-cards",
        title: "ID Cards",
        activeIcon: "./assets/img/images/id-cards-menu-icon-active.svg",
        nonActiveIcon: "./assets/img/images/icon-id-card.svg"
      });
    }     
    if(!this.isAcmic && existMA) {
      this.hiddenNavItems.push({
        routerLink: "/faq",
        title: "FAQ",
        activeIcon: "./assets/img/images/menuicon-faq-active.svg",
        nonActiveIcon: "./assets/img/images/menuicon-faq.svg"
      });
    }
  }

  routeEvent(){
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        this.showMore = false;
        this.lockScreen.emit(false);
      }
    })
  }

  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }
}
